// Serverpflicht aus Anmeldung/me; Merker nur für die Übergangsantwort alter Backends.
const KEY = 'partner_phone_verification_pending';

const read = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || 'null');
    return value && (typeof value.userId === 'string' || typeof value.userId === 'number') ? value : null;
  } catch { return null; }
};

export function rememberPendingPhone(userId, target) {
  if (userId == null) return;
  try { localStorage.setItem(KEY, JSON.stringify({ userId, target: typeof target === 'string' ? target : null })); } catch {}
}

export function forgetPendingPhone() {
  try { localStorage.removeItem(KEY); } catch {}
}

// Code-Schritt für diese Sitzung oder null. `phone_verified` kommt vom Server (/auth/me bzw. Anmeldung).
export function pendingPhoneFor(user) {
  if (user?.role !== 'partner' || user.id == null) return null;
  // Serverzustand hat Vorrang; der Merker überbrückt nur alte Backendantworten.
  if (Number(user.phone_verified) === 1 || user.phone_verified === true || user.phone_verification_required === false) {
    forgetPendingPhone(); return null;
  }
  if (user.phone_verification_required === true) return {
    channel: null, target: typeof user.masked_phone === 'string' ? user.masked_phone : null,
    resendAt: 0, restored: true, phoneMissing: user.phone_missing === true,
  };
  const marker = read();
  if (!marker || String(marker.userId) !== String(user.id)) return null;
  return { channel: null, target: marker.target || null, resendAt: 0, restored: true };
}
